<template>
  <section class="s-proc" aria-labelledby="insurance-process-title">
    <header class="s-proc__header">
      <h2 id="insurance-process-title" class="wd-title">
        <span class="s-proc__base">¿Qué ocurre si tu reclamación</span> <span class="hl">es procedente?</span>
      </h2>
      <p class="wd-body">
        Selecciona una opción para conocer <br class="br-m">los requisitos y pasos que debes seguir.
      </p>
    </header>

    <div class="s-proc__cards">
      <article v-for="card in cards" :key="card.title" class="s-proc__card">
        <div class="s-proc__head">
          <img :src="markerIcon" alt="" aria-hidden="true">
          <h3>{{ card.title }}</h3>
        </div>

        <template v-for="block in card.blocks" :key="block.label">
          <p class="s-proc__label" :class="{ 's-proc__label--dark': block.dark }">{{ block.label }}</p>
          <p v-if="block.text" class="wd-body">{{ block.text }}</p>
          <ul v-if="block.list" class="s-proc__list">
            <li v-for="item in block.list" :key="item">{{ item }}</li>
          </ul>
        </template>
      </article>
    </div>
  </section>
</template>

<script setup lang="ts">
import markerIcon from '../../../assets/seguros-figma/marker.png'

interface Block {
  label: string
  text?: string
  list?: string[]
  dark?: boolean
}

const optar = 'El titular o los beneficiarios podrán optar por:'
const opciones = ['Cancelación sin pena convencional.', 'Cesión de derechos sin costo.']
const notificacion = 'Se notificará la procedencia o no de la reclamación.'

const cards: { title: string; blocks: Block[] }[] = [
  {
    title: 'Integrante',
    blocks: [
      {
        label: 'Fallecimiento o invalidez procedente',
        text: 'Los contratos se adjudican de forma directa y se entrega al titular o beneficiarios el monto adjudicado, descontando el CCI.'
      },
      { label: 'Fallecimiento o invalidez no procedente' },
      { label: optar, dark: true, list: opciones },
      { label: 'Desempleo', text: notificacion }
    ]
  },
  {
    title: 'Adjudicatario',
    blocks: [
      {
        label: 'Fallecimiento o invalidez procedente',
        text: 'Se entrega al titular o beneficiarios el monto adjudicado, descontando el CCI.'
      },
      { label: 'Fallecimiento o invalidez no procedente' },
      { label: optar, dark: true, list: opciones },
      { label: 'Desempleo', text: notificacion }
    ]
  },
  {
    title: 'Adjudicado',
    blocks: [
      {
        label: 'Fallecimiento o invalidez procedente',
        text: 'Se liquida el saldo insoluto del financiamiento y se emite la carta de liberación de hipoteca.'
      },
      {
        label: 'Fallecimiento o invalidez no procedente',
        text: 'Se mantiene la obligación de pago del titular o de los beneficiarios.'
      },
      {
        label: 'Desempleo procedente',
        text: 'La aseguradora podrá cubrir hasta tres cuotas mensuales, siempre que el asegurado continúe desempleado y se cumplan las condiciones de la póliza.'
      }
    ]
  }
]
</script>

<style scoped>
.s-proc { display: flex; flex-direction: column; gap: var(--ds-space-5); }
.s-proc__header { display: flex; flex-direction: column; gap: var(--ds-space-3); }
.s-proc__base { color: var(--ds-purple-900); }

.s-proc__cards { display: flex; flex-direction: column; gap: var(--ds-space-5); }
.s-proc__card {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: var(--ds-space-5) var(--ds-space-6);
  box-sizing: border-box;
  background: var(--ds-grey-50);
  border-radius: 16px;
}

.s-proc__head { display: flex; align-items: center; gap: var(--ds-space-4); min-height: 32px; }
.s-proc__head img { flex: 0 0 16px; width: 16px; height: 16px; }
.s-proc__head h3 { margin: 0; color: var(--ds-purple-900); font-size: 18px; font-weight: 600; line-height: normal; }

.s-proc__label { margin: 0; color: var(--ds-purple-900); font-size: 16px; font-weight: 600; line-height: 24px; }
.s-proc__label--dark { color: var(--ds-text-body); }
.s-proc__card .wd-body { margin: 0; }

.s-proc__list { margin: 0; padding: 0 0 0 var(--ds-space-5); color: var(--ds-text-body); font-size: 16px; line-height: 24px; }

@media (max-width: 1024px) {
  .s-proc__card { padding: var(--ds-space-5); }
}

@media (max-width: 599px) {
  .s-proc__card { padding: var(--ds-space-4); }
}
</style>
